'use strict';

// @ngInject
DropdownMenuBtnController.$inject = ["$scope", "$timeout"];
function DropdownMenuBtnController($scope, $timeout) {
  this.onClick = function () {
    $scope.onClick();
  };

  this.toggleDropdown = function($event) {
    $event.stopPropagation();
    $timeout(function () {
      $scope.onToggleDropdown();
    }, 0);
  };
}

module.exports = function () {
  return {
    controller: DropdownMenuBtnController,
    controllerAs: 'vm',
    restrict: 'E',
    scope: {
      isDisabled: '<',
      label: '<',
      dropdownMenuLabel: '@',
      onClick: '&',
      onToggleDropdown: '&',
    },
    template: require('../../../templates/client/dropdown_menu_btn.html'),
  };
};
